import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Row, Col, Modal, Table, Form, Input, Spin, Select, Popconfirm, message, Tag, Tooltip } from 'antd';
import FeatherIcon from 'feather-icons-react';
import { PageHeader } from '../page-headers/page-headers';
import { Main, TableWrapper, BasicFormWrapper, AddUser } from '../../container/styled';
import { Button } from '../buttons/buttons';
import { Cards } from '../cards/frame/cards-frame';
import { createProduct, updateProduct, fetchCategories, fetchOptions } from '../../redux/products/actionCreator';
import { DataService } from '../../config/dataService/dataService';
import { API } from '../../config/api/index';

const { Option } = Select;

const ProductsTable = ({ pageNumber, onChangePageNumber, onDeleteProduct }) => {
  const { categories = [] } = useSelector(state => state.pos);
  const { options = {} } = useSelector(state => state.products);
  const { filterProducts, products = [], loadingCreate, total = 0 } = useSelector(state => {
    return {
      filterProducts: state.products.filterProducts,
      products: state.products.products,
      loadingCreate: state.products.loadingCreate,
      total: state.products.totalResults,
    };
  });
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchOptions());
    dispatch(fetchCategories());
  }, [dispatch]);

  const [state, setState] = useState({
    notData: filterProducts,
    selectedRowKeys: [],
    update: { name: '', price: 0, category: { id: '', name: '' }, options: {} },
    modalVisible: false,
    modalCategoryVisible: false,
    modalUpdateVisible: false,
    idToUpdate: '',
    optionsArray: [],
    loading: false,
    selectedProduct: null,
  });

  const [productForm] = Form.useForm();
  const [formCategory] = Form.useForm();

  const handleOnChangePage = params => {
    onChangePageNumber(params);
  };
  const handleOnDeleteUser = id => {
    onDeleteProduct(id);
  };
  const handleCancel = () => {
    setState({ ...state, modalVisible: false, modalUpdateVisible: false });
  };

  const toggleModalCategory = () => {
    setState({
      ...state,
      modalCategoryVisible: !state.modalCategoryVisible,
    });
  };

  const handleCancelCategory = () => {
    formCategory.resetFields();
    toggleModalCategory();
  };

  const handleOk = data => {
    dispatch(createProduct(data));
    onChangePageNumber(1);
    productForm.resetFields();
    setState({ ...state, modalVisible: false });
  };

  const handleOkCategory = async values => {
    setState({ ...state, loading: true });
    try {
      await DataService.post(API.pos.categories, values);
      message.success('Categoría creada exitosamente');
      dispatch(fetchCategories());
      formCategory.resetFields();
      setState(prevState => ({
        ...prevState,
        loading: false,
        modalCategoryVisible: false,
      }));
    } catch (error) {
      message.error('Error al crear la categoría');
      setState(prevState => ({
        ...prevState,
        loading: false,
      }));
    }
  };

  const handleOkDataUpdate = form => {
    console.log('form', form);

    dispatch(updateProduct({ ...form, idToUpdate: state.idToUpdate }));
    onChangePageNumber(1);
  };

  const toggleModal = () => {
    setState({ ...state, modalVisible: !state.modalVisible });
  };

  const handleOnShowDataUpdate = (idToUpdate, name, price, category, opciones) => {
    setState({
      ...state,
      modalUpdateVisible: !state.modalUpdateVisible,
      idToUpdate,
      update: { name, price: `${price}`, category, options: opciones },
      optionsArray: opciones.map(option => option.id),
    });
    productForm.setFieldsValue({
      name,
      price: `${price}`,
      category: category?.id,
      options: opciones.map(option => option.id),
    });
  };

  const handleOnChangeOptionSelect = value => {
    setState({
      ...state,
      update: { ...state.update, options: value },
      optionsArray: value,
    });
    productForm.setFieldsValue({
      options: value,
    });
  };

  const closeModalUpdate = () => {
    setState({
      ...state,
      modalUpdateVisible: !state.modalUpdateVisible,
      idToUpdate: '',
      update: { name: '', price: '0', category: { id: '', name: '' }, options: [] },
      optionsArray: [],
    });
    productForm.setFieldsValue({ name: '', price: '0', category: '', options: [] });
  };

  const dataSource = [];
  if (products?.length) {
    let iteareProp = products;
    if (filterProducts?.length > 0) iteareProp = filterProducts;
    iteareProp.map((value, key) => {
      const { id, name, price, category, options: opciones } = value;
      return dataSource.push({
        key: key + 1,
        id: <span className="product-id">{id.substring(8)}</span>,
        name: <span className="name">{name}</span>,
        price: <span className="price">${price}</span>,
        category: <span className="category">{category.name}</span>,
        options: (
          <div>
            {opciones && opciones.length > 0 ? (
              opciones.map((option, idx) => (
                <Tooltip
                  key={idx}
                  title={
                    <div>
                      <div>
                        <strong>Tipo:</strong>{' '}
                        {option.type === 'BOOLEAN'
                          ? 'Selección Única'
                          : option.type === 'COUNTER'
                          ? 'Selección Múltiple'
                          : option.type || 'N/A'}
                      </div>
                      <div>
                        <strong>Obligatorio:</strong> {option.mandatory ? 'Sí' : 'No'}
                      </div>
                      <div>
                        <strong>Selecciones:</strong>
                      </div>
                      {option.options && option.options.length > 0 ? (
                        <ul style={{ paddingLeft: 20, margin: 0 }}>
                          {option.options.map((sel, sidx) => (
                            <li key={sidx}>
                              {sel.title} {sel.extraPrice > 0 && `(+$${sel.extraPrice})`}
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <span>Sin selecciones</span>
                      )}
                    </div>
                  }
                >
                  <Tag
                    color={option.mandatory ? '#f5222d' : '#1890ff'}
                    style={{
                      marginBottom: 4,
                      cursor: 'pointer',
                      fontWeight: 500,
                      border: option.mandatory ? '1px solid #cf1322' : '1px solid #096dd9',
                    }}
                  >
                    {option.name} ({option.options?.length || 0})
                  </Tag>
                </Tooltip>
              ))
            ) : (
              <Tag color="#d9d9d9" style={{ color: '#8c8c8c', fontWeight: 500 }}>
                Sin opciones
              </Tag>
            )}
          </div>
        ),
        action: (
          <div className="table-actions">
            <>
              <Button
                className="btn-icon"
                type="warning"
                onClick={() => handleOnShowDataUpdate(id, name, price, category, opciones)}
                shape="circle"
              >
                <FeatherIcon icon="edit" size={16} />
              </Button>
              <Popconfirm
                title="¿Seguro que quieres borrar este producto?"
                onConfirm={() => {
                  handleOnDeleteUser(id);
                }}
                okText="Si"
                cancelText="No"
              >
                <Button className="btn-icon" type="danger" shape="circle">
                  <FeatherIcon icon="trash-2" size={16} />
                </Button>
              </Popconfirm>
            </>
          </div>
        ),
      });
    });
  }

  const columns = [
    {
      title: 'Id',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Precio',
      dataIndex: 'price',
      key: 'price',
    },
    {
      title: 'Categoría',
      dataIndex: 'category',
      key: 'category',
    },
    {
      title: 'Opciones',
      dataIndex: 'options',
      key: 'options',
    },
    {
      title: 'Acción',
      dataIndex: 'action',
      key: 'action',
    },
  ];

  return (
    <>
      <PageHeader
        ghost
        title="Productos"
        buttons={[
          <div key="1" className="page-header-actions">
            <Button
              className="btn-add_new"
              size="default"
              key="1"
              type="primary"
              onClick={toggleModal}
              style={{ marginRight: '10px' }}
            >
              <FeatherIcon icon="plus-square" size={14} /> Agregar Producto
            </Button>
            <Button className="btn-add_new" size="default" key="2" type="primary" onClick={toggleModalCategory}>
              <FeatherIcon icon="folder-plus" size={14} /> Agregar Categoría
            </Button>
          </div>,
        ]}
      />
      <Main>
        <Modal title="Información del producto" visible={state.modalVisible} footer={null} onCancel={handleCancel}>
          <div className="project-modal">
            <BasicFormWrapper>
              <AddUser>
                <Form form={productForm} name="product" onFinish={handleOk}>
                  <Form.Item label="Nombre" name="name" rules={[{ required: true, message: 'Ingresa un nombre' }]}>
                    <Input placeholder="Nombre del producto" />
                  </Form.Item>

                  <Form.Item
                    label="Precio"
                    name="price"
                    rules={[{ required: true, message: 'Ingresa un precio para el producto', type: 'string' }]}
                  >
                    <Input placeholder="$55" />
                  </Form.Item>

                  <Form.Item label="Categoría" name="category">
                    <Select
                      placeholder="Categoría"
                      showSearch
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      style={{ width: 220 }}
                      rules={[{ required: true, message: 'Selecciona una categoría' }]}
                    >
                      {categories.map(category => (
                        <Option key={category.id} value={category.id}>{`${category.name}`}</Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item label="Opciones" name="options">
                    <Select
                      placeholder="Opciones"
                      mode="multiple"
                      showSearch
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      style={{ width: 220 }}
                      rules={[{ required: false, message: 'Selecciona las opciones requeridas' }]}
                    >
                      {options.map(option => (
                        <Option key={option.id} value={option.id}>{`${option.name}`}</Option>
                      ))}
                    </Select>
                  </Form.Item>

                  {loadingCreate ? (
                    <Spin />
                  ) : (
                    <Button htmlType="submit" size="default" type="primary" key="submit">
                      Agregar Nuevo Producto
                    </Button>
                  )}
                </Form>
              </AddUser>
            </BasicFormWrapper>
          </div>
        </Modal>

        <Modal
          title="Nueva Categoría"
          visible={state.modalCategoryVisible}
          footer={null}
          onCancel={handleCancelCategory}
        >
          <div className="project-modal">
            <BasicFormWrapper>
              <AddUser>
                <Form form={formCategory} name="category" onFinish={handleOkCategory}>
                  <Form.Item
                    label="Nombre"
                    name="name"
                    rules={[{ required: true, message: 'Por favor ingresa el nombre de la categoría' }]}
                  >
                    <Input placeholder="Nombre de la categoría" />
                  </Form.Item>

                  <Button htmlType="submit" size="default" type="primary" key="submit">
                    Crear Categoría
                  </Button>
                </Form>
              </AddUser>
            </BasicFormWrapper>
          </div>
        </Modal>

        <Modal title="Actualizar producto" visible={state.modalUpdateVisible} footer={null} onCancel={closeModalUpdate}>
          <div className="project-modal">
            <BasicFormWrapper>
              <AddUser>
                <Form form={productForm} name="updateData" onFinish={handleOkDataUpdate}>
                  <Form.Item label="Nombre" name="name" rules={[{ required: false, message: 'Ingresa un nombre' }]}>
                    <div>
                      <Input
                        placeholder="Nombre del producto"
                        onChange={value =>
                          setState({ ...state, update: { ...state.update, name: value?.target?.value } })
                        }
                        value={state.update.name}
                      />
                    </div>
                  </Form.Item>

                  <Form.Item
                    label="Precio"
                    name="price"
                    rules={[{ required: false, message: 'Ingresa un precio para el producto', type: 'string' }]}
                  >
                    <div>
                      <Input
                        placeholder="$55"
                        onChange={value =>
                          setState({ ...state, update: { ...state.update, price: value?.target?.value } })
                        }
                        value={state.update.price}
                      />
                    </div>
                  </Form.Item>

                  <Form.Item label="Categoría" name="category">
                    <div>
                      <Select
                        placeholder="Categoría"
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        style={{ width: 220 }}
                        rules={[{ required: false, message: 'Selecciona una categoría' }]}
                        onSelect={value => {
                          setState({
                            ...state,
                            update: { ...state.update, category: { id: value } },
                          });
                        }}
                        value={state.update.category.id}
                      >
                        {categories.map(category => (
                          <Option key={category.id} value={category.id}>{`${category.name}`}</Option>
                        ))}
                      </Select>
                    </div>
                  </Form.Item>

                  <Form.Item label="Opciones" name="options">
                    <div>
                      <Select
                        placeholder="Opciones"
                        mode="multiple"
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        style={{ width: 220 }}
                        rules={[{ required: false, message: 'Selecciona las opciones requeridas' }]}
                        onChange={handleOnChangeOptionSelect}
                        value={state.optionsArray}
                      >
                        {options.map(option => (
                          <Option key={option.id} value={option.id}>{`${option.name}`}</Option>
                        ))}
                      </Select>
                    </div>
                  </Form.Item>

                  {loadingCreate ? (
                    <Spin />
                  ) : (
                    <Button htmlType="submit" size="default" type="primary" key="submit">
                      Actualizar Producto
                    </Button>
                  )}
                </Form>
              </AddUser>
            </BasicFormWrapper>
          </div>
        </Modal>
        <Cards headless>
          <Row gutter={15}>
            <Col md={24}>
              <TableWrapper className="table-user table-responsive">
                <Table
                  dataSource={dataSource}
                  columns={columns}
                  pagination={{
                    current: pageNumber,
                    onChange: handleOnChangePage,
                    total,
                  }}
                />
              </TableWrapper>
            </Col>
          </Row>
        </Cards>
      </Main>
    </>
  );
};

ProductsTable.propTypes = {
  pageNumber: PropTypes.number,
  onChangePageNumber: PropTypes.func,
  onDeleteProduct: PropTypes.func,
};
export default ProductsTable;
